import noop from "lodash/noop";
import { PostSpaceActions } from "@circle-react/components/Spaces/Header/SpaceHeaderActions/PostSpaceActions";
import { isSortingEnabled } from "@circle-react/helpers/spaceHelpers";
import { useLargeScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import type { Space } from "@circle-react/types";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { LeaveAndDeleteSpaceOptions } from "./LeaveAndDeleteSpaceOptions";
import { ManageSpaceOptions } from "./ManageSpaceOptions";
import { NotificationsOptions } from "./NotificationsOptions";
import { PostSortOptions } from "./PostSortOptions";

export interface PostSpaceOptionsProps {
  canMemberManageSpace: boolean;
  isAdmin: boolean;
  isMember: boolean;
  onAddCoverImage?: () => void;
  onInviteMember?: () => void;
  space: Space;
}

export const PostSpaceOptions = ({
  space,
  isAdmin,
  canMemberManageSpace,
  isMember,
  onInviteMember = noop,
  onAddCoverImage = noop,
}: PostSpaceOptionsProps) => {
  const isSortingEnabledForSpace = isSortingEnabled(space);
  const isLgScreen = useLargeScreenMediaQuery();

  return (
    <>
      {isMember && (
        <div className="md:hidden">
          <PostSpaceActions space={space} />
          <Dropdown.Separator />
          {isSortingEnabledForSpace && (
            <>
              <PostSortOptions space={space} />
              <Dropdown.Separator />
            </>
          )}
        </div>
      )}

      {canMemberManageSpace && (
        <ManageSpaceOptions
          space={space}
          onInviteMember={onInviteMember}
          onAddCoverImage={onAddCoverImage}
        />
      )}

      {((isMember && isLgScreen) || canMemberManageSpace) && (
        <Dropdown.Separator />
      )}

      <NotificationsOptions space={space} />

      <LeaveAndDeleteSpaceOptions
        space={space}
        isAdmin={isAdmin}
        onInviteMember={onInviteMember}
      />
    </>
  );
};
